import React from "react";
import { AiOutlineLink, AiOutlineMail } from "react-icons/ai";
import { FiPhoneCall } from "react-icons/fi";
import { useTranslation } from 'react-i18next';
import "./Contact.css";

const Contact = () => {
	const { t } = useTranslation();
	
	return (
		<section className="content_section" id="contact">
			<div className="content_section_inner">
				<h2>{t('contact.title')}</h2>
				<div className="container">
					<div className="col col-1-3 contact-infos">
						<div className="contact-cta">
							<h4 style={{ marginBottom: "10px" }}>
								{t('contact.subtitle')}
							</h4>
							<p>
								{t('contact.description')}
							</p>
						</div>
						<div className="contact-links">
							<div className="contact-links-item">
								<div className="icon">
									<AiOutlineMail />
								</div>
								<p>
									{t('contact.info.email')}
									<a href="mailto:info@enovatic.be">
										info@enovatic.be
									</a>
								</p>
							</div>
							<div className="contact-links-item">
								<div className="icon">
									<FiPhoneCall />
								</div>
								<p>
									{t('contact.info.phone')}
									<a href="tel:+320484295694">
										+32 (0) 484 29 56 94
									</a>
								</p>
							</div>
							<div className="contact-links-item">
								<div className="icon">
									<AiOutlineLink />
								</div>
								<p>
									{t('contact.info.website')}
									<a
										href="https://enovatic.be" 
										target="_blank"
										rel="noreferrer"  
									>
										Enovatic.be
									</a>
								</p>
							</div>
						</div>
					</div>
					<div className="col col-2-3 contact-form">
						<div className="container-form-grid">
							<input
								name="contact-lastname"
								type="text"
								placeholder={t('contact.form.lastName')}
								className="contact-lastname col"
							/>
							<input
								name="contact-firstname"
								type="text"
								placeholder={t('contact.form.firstName')}
								className="contact-firstname col"
							/>
							<input
								name="contact-phone"
								type="text"
								placeholder={t('contact.form.phone')}
								className="contact-phone col"
							/>
							<input
								name="contact-email"
								type="email"
								placeholder={t('contact.form.email')}
								className="contact-email col"
							/>
							<input
								name="contact-subject"
								type="text"
								placeholder={t('contact.form.subject')}
								className="contact-subject col col-full"
							/>
							<textarea
								name="contact-message"
								className="contact-message col col-full"
								placeholder={t('contact.form.message')}
								cols="30"
								rows="6"
							></textarea>
							<input
								type="submit"
								name="contact-submit"
								className="contact-submit col"
								value={t('contact.form.send')}
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Contact;
